import React from 'react';
import styled from 'styled-components';
import { PREFERRED_MINIMUM_RATE_PER_MILE } from '../../../../supplementary_components/companySettings';

// const HEADER = styled.div`
//     color: var(--light-gray);
//     font-size
// `
// const Value = styled.div`

// `
const Container = styled.div`
    
    &>div:not(.totalAmount, .noFeesOrCharges){
        display:grid;
        margin-bottom:0.3rem;
        &>:last-child{
            margin-left: auto; 
            margin-right: 0;
            text-align:right;
        }
        .firstLbl{
            color:var(--light-gray);
            margin-bottom:0.5rem;
        }
        .lbl{
            color:var(--light-gray);
            margin-bottom:0.5rem;
            margin-top:2rem;
        }
        
        .MainValue{
            font-size:${props => props.$smallerfont ? "1.3rem" : "1.5rem"};
            color:var(--dark-gray);
            font-weight:bold;
        }
        .val{
            margin-top:0.3rem;
            font-weight:500;
            font-weight:bold;
            color:var(--dark-gray);
            &>span{
                color: var(--light-gray);
            }
        }
        .positive{
            color:var(--main-color);
        }
        .negative{
            color:var(--alert-color);
            
        }
        .neutral{
            color:var(--light-gray);
        }
        .payoutSet{
            color: rgba(var(--successGreenRGB), 0.9);
        }
        .payoutNotSet{
            color: var(--light-gray);
        }
    }
`
// const NoFeesOrCharges = styled.div`
//     color:red;
//     text-align:center;
//     font-weight:bold;
//     font-size:1.5em;
//     color:var(--extra-light-gray);
//     padding: 1rem 0rem;
// `
const AmountForInvoice = styled.div`
    margin-top:2rem;
    font-size:${props => props.$smallerfont ? "1.6rem" : "1.8rem"};
    font-weight:bold;
    margin-left: auto; 
    margin-right: 0;
    text-align:right;
    color:var(--dark-gray);
    &>span{
        color:var(--light-gray);
    }
`;
export const LoadPayoutSection = ({data, smallerFont, driverPayoutIsEditable, driverPayoutDisplay, canSeeRates = true, hideDriverPayoutAmount = false})=> {
    const rateDisplay = canSeeRates ? `$${data.payout}` : "-";
    const invoiceDisplay = canSeeRates ? `$${data.amountForInvoice}` : "-";
    const rpmDisplay = !canSeeRates
        ? "-"
        : (data.mileage ? '$'+(data.payout / (data.mileage+data.deadhead)).toFixed(2) : '-');
    const rpmClass = canSeeRates && data.mileage
        ? ((data.payout / (data.mileage+data.deadhead)).toFixed(2) > PREFERRED_MINIMUM_RATE_PER_MILE ? "positive" : "negative")
        : '';

    const showDriverPayout = driverPayoutIsEditable && canSeeRates;
    // Prefer formatted columns. Updaters (hideAmount): Set / Not Set, never $.
    const payoutColumns = (() => {
        if (!showDriverPayout) return [];
        if (Array.isArray(driverPayoutDisplay?.columns) && driverPayoutDisplay.columns.length > 0) {
            return driverPayoutDisplay.columns;
        }
        if (hideDriverPayoutAmount) {
            const set = Boolean(driverPayoutDisplay?.isSet);
            return [{
                label: 'Driver Payout',
                text: set ? 'Set' : 'Not Set',
                className: set ? 'payoutSet' : 'payoutNotSet',
            }];
        }
        return [{
            label: 'Driver Payout',
            text: driverPayoutDisplay?.text ?? 'Not Set',
            className: driverPayoutDisplay?.className || '',
        }];
    })();

    const invoiceAmount = Number(data.amountForInvoice) || 0;
    const classForPayoutColumn = (col) => {
        let cls = col.className || driverPayoutDisplay?.className || '';
        if (!hideDriverPayoutAmount && canSeeRates && col.amount != null && Number(col.amount) > invoiceAmount) {
            cls = 'negative';
        } else if (
            !hideDriverPayoutAmount
            && canSeeRates
            && col.amount == null
            && Array.isArray(driverPayoutDisplay?.amounts)
            && driverPayoutDisplay.amounts.reduce((s, n) => s + (Number(n) || 0), 0) > invoiceAmount
            && payoutColumns.length === 1
        ) {
            cls = 'negative';
        }
        return cls;
    };

    const buildGridTemplateColumns = () => {
        if (!showDriverPayout || payoutColumns.length === 0) {
            return "45% 1fr 0.3fr";
        }
        if (payoutColumns.length === 1) {
            return "30% 1fr 1fr 0.3fr";
        }
        // Rate + one column per truck + Mileage + RPM
        const truckCols = payoutColumns.map(() => 'minmax(4.5rem, 0.85fr)').join(' ');
        return `minmax(22%, 0.9fr) ${truckCols} minmax(7rem, 1.1fr) 0.3fr`;
    };

    return <Container $smallerfont={smallerFont}>
        <div style={{gridTemplateColumns: buildGridTemplateColumns()}}>
            <div>
                <div className='firstLbl'>
                    Rate
                </div>
                <div className='MainValue'>
                    {rateDisplay}
                </div>
            </div>
            {payoutColumns.map((col, index) => (
                <div key={`${col.label}-${index}`}>
                    <div className='firstLbl'>
                        {col.label}
                    </div>
                    <div className={`val ${classForPayoutColumn(col)}`}>
                        {col.text}
                    </div>
                </div>
            ))}
            <div>
                <div className='firstLbl'>
                    Total Mileage ({`${data.mileage && data.deadhead ? "Loaded/" : ""}`}DH)
                </div>
                <div className='val'>
                    {`${data.mileage  ? data.mileage + (data.deadhead  ? data.deadhead : 0) : '-'}`}{<span>{` (${data.mileage && data.deadhead ? data.mileage +"/"  : ""}${data.deadhead ? data.deadhead : "n/a"})`}</span>}
                </div>
            </div>
            <div>
                <div className='firstLbl'>
                    RPM
                </div>
                <div className={`val ${rpmClass}`}>
                    {rpmDisplay}
                </div>
            </div>
        </div>
        {
            data.feesAndCharges ? data.feesAndCharges.map((feesAndCharges, index ) => {
                let withLabel = true;
                if (index > 0)withLabel = false;
                return  <div key={`${feesAndCharges.desc}${index}`} style={{gridTemplateColumns:"47% 1fr 1fr"}}>
                    {chargeOrFeeGenerator(feesAndCharges, withLabel)}
                </div>
            }) : <></>
        }
        {
            data.driverChargesAndBonuses ? data.driverChargesAndBonuses.map((chargeOrBonus, index) => {
                let withLabel = true;
                if (index > 0)withLabel = false;
                
                return  <div key={`${chargeOrBonus.desc}${index}`} style={{gridTemplateColumns:"47% 1fr 1fr"}}>
                    {chargeOrFeeGenerator(chargeOrBonus, withLabel)}
                </div>
            }) : <></>
        }
        {(data.feesAndCharges === null && data.driverChargesAndBonuses === null)? <></>:<></>}
        
        
        <AmountForInvoice className='totalAmount' $smallerfont={smallerFont}>
            <span>Invoice Amount:&nbsp;</span> {invoiceDisplay}
        </AmountForInvoice>
    </Container>

}
//<NoFeesOrCharges className='noFeesOrCharges'>No Fees or Charges</NoFeesOrCharges>
const showDriverFullName = (val) => {
    const parsed = typeof(val) === 'string' ? JSON.parse(val) : val;
    return `${parsed.firstName} ${parsed.lastName} (${parsed.currentTruckNumber})`
}
const chargeOrFeeGenerator = (item, withLabel, ) =>{
    if(typeof(item) === 'string')item = JSON.parse(item)
    
    return <>
    <div>
        {withLabel?<div className='lbl'>{`${item.driver?"Driver Bonuses/Charges" : "Fees and Charges"}`}</div>:<></>}
        <div className='val'>
        {item.driver? `${showDriverFullName(item.driver)} ` : item.desc }
        </div>
    </div>
    <div>
    {withLabel?<div className='lbl'>Amount</div>:<></>}
        <div className={`val ${item.type ? item.type === "charge" ? 'negative' : "positive"  : ''} `}>
        {item.driver? `$${item.amount} (${item.desc})` : `$${item.amount}` }
        </div>
    </div>
    <div>
        {withLabel?<div className='lbl'>Status</div>:<></>}
        <div className={`val ${StatusGenerator(item.status).className}`}>
            {StatusGenerator(item.status).text}
        </div>
    </div> </>
}
const StatusGenerator = (status)=>{
    switch (status) {
        case 'reimbursed':
            return {text:"Reimbursed", className:"positive"};
        case 'notReimbursed':
            return {text:"Not Reimbursed", className:"negative"};
        case 'charged':
            return {text:"Charged", className:"negative"};
        case 'pending':
            return {text:"Pending", className:"neutral"};
        case 'inReview':
            return {text:"In Review", className:"neutral"};
        case 'approved':
            return {text:"Approved", className:"positive"};
        case 'dismissed':
            return {text:"Dismissed", className:"neutral"};
        case undefined:
            return {text:"Pending", className:"neutral"};
        default:
            return "";
    }
}
// <div key={`${fee.desc}${index}`}>
                //     {withLabel?<div className='lbl'>Additional Fees</div>:<></>}
                //     <div className='val'>
                //         {`$${fee.desc}`}
                //     </div>
                //     <div className='val'>
                //         {`$${data.payout}`}
                //     </div>
                // </div>